// frontend/src/components/DocumentTemplateList/DocumentTemplateList.js

import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../apiClient';
import { UserContext } from '../../UserContext';
import { toast } from 'react-toastify';
import './DocumentTemplateList.css';

function DocumentTemplateList() {
  const [templates, setTemplates] = useState([]);
  const [clinics, setClinics] = useState([]);
  const [selectedClinicId, setSelectedClinicId] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [showDropdownId, setShowDropdownId] = useState(null);


  const fetchClinics = () =>
    apiClient.get('/api/clinics')
      .then(res => setClinics(res.data))
      .catch(err => console.error('Fel vid hämtning av kliniker:', err));

  const fetchTemplates = () =>
    apiClient.get('/api/documentmallar')
      .then(res => setTemplates(res.data))
      .catch(err => {
        console.error('Fel vid hämtning av dokumentmallar:', err);
        setError('Misslyckades att hämta dokumentmallar.');
      });

  useEffect(() => {
    fetchTemplates();
    fetchClinics();
  }, []);

  const copyTemplate = async (templateId, clinicId) => {
    try {
      await apiClient.post(`/api/documentmallar/${templateId}/copy`, {
        clinic_id: clinicId
      });
      toast.success('Mall kopierad!');
      fetchTemplates();
    } catch (err) {
      console.error('Kopiering misslyckades:', err);
      toast.error(err.response?.data?.msg || 'Kopiering misslyckades');
    }
  };

  const handleDelete = (id) => {
    if (window.confirm('Vill du ta bort denna dokumentmall?')) {
      apiClient.delete(`/api/documentmallar/${id}`)
        .then(() => setTemplates(templates.filter(t => t.template_id !== id)))
        .catch(err => {
          console.error('Fel vid borttagning:', err);
          setError('Misslyckades att ta bort dokumentmall.');
        });
    }
  };

  const handleCreate = () => navigate('/documentmallar/create');
  const handleEdit = (id) => navigate(`/documentmallar/edit/${id}`);

  const clinicMap = clinics.reduce((acc, c) => ({ ...acc, [c.clinic_id]: c.clinic_name }), {});
  const filteredTemplates = selectedClinicId
    ? templates.filter(t => t.clinic_id === parseInt(selectedClinicId, 10))
    : templates;

  return (
    <div style={{ padding: '20px' }}>
      <h2>Dokumentmallar</h2>

      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="clinic-filter">Filtrera efter klinik: </label>
        <select
          id="clinic-filter"
          value={selectedClinicId}
          onChange={(e) => setSelectedClinicId(e.target.value)}
        >
          <option value="">-- Alla kliniker --</option>
          {clinics.map(c => (
            <option key={c.clinic_id} value={c.clinic_id}>{c.clinic_name}</option>
          ))}
        </select>
      </div>

      {user?.is_admin && (
        <button onClick={handleCreate} className="create-button">
          Skapa Ny Dokumentmall
        </button>
      )}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <table className="document-template-table">
        <thead>
          <tr>
            <th>Mallnamn</th>
            <th>Klinik</th>
            <th>Åtgärder</th>
          </tr>
        </thead>
        <tbody>
          {filteredTemplates.map(t => (
            <tr key={t.template_id}>
              <td>{t.template_name}</td>
              <td>{clinicMap[t.clinic_id] || 'Global'}</td>
              <td>
                <div className="action-buttons">
                  {user?.is_admin && clinics.length > 0 && (
                    <div className="copy-dropdown-container">
                      <button
                        className="copy-button"
                        onClick={() => setShowDropdownId(showDropdownId === t.template_id ? null : t.template_id)}
                      >
                        Kopiera till…
                      </button>
                      {showDropdownId === t.template_id && (
                        <div className="clinic-dropdown-menu">
                          {clinics.map(c => (
                            <div
                              key={c.clinic_id}
                              className="clinic-dropdown-item"
                              onClick={() => {
                                copyTemplate(t.template_id, c.clinic_id);
                                setShowDropdownId(null);
                              }}
                            >
                              {c.clinic_name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  <button
                    onClick={() => navigate(`/documentmallar/edit/${t.template_id}`)}
                    className="edit-button"
                  >
                    Redigera
                  </button>
                  <button
                    onClick={() => handleDelete(t.template_id)}
                    className="delete-button"
                  >
                    Ta Bort
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DocumentTemplateList;
